module.exports = __webpack_public_path__ + "img/Map Button_open.14cf9656.svg";